import { focusManager } from 'react-query';
import { toastNotification } from '../../components/toast/Toast';

type FileInputProps = {
    innerRef: React.MutableRefObject<HTMLInputElement | null>;
    onSelect: (files: File[]) => void;
    disabled?: boolean;
    multiple?: boolean;
    fileTypes?: string[];
};

function FileInput({ innerRef, onSelect, disabled = false, multiple = false, fileTypes }: FileInputProps): JSX.Element {
    function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        focusManager.setFocused(undefined);
        const filelist = e.target.files;
        const fileLimit = 30;

        if (filelist) {
            const files = Array.from(filelist);
            if (files.length > fileLimit) {
                toastNotification('error', `You can't upload more than ${fileLimit} files.`);
                return;
            }
            onSelect(files);
        }
    }

    function handleClick(): void {
        // Opening an input dialog will create a window re-focus event , causing react-query to not work as intended
        focusManager.setFocused(false);
        // Reset the file input
        if (innerRef?.current) {
            innerRef.current.value = '';
        }
    }

    return (
        <input
            disabled={disabled}
            multiple={multiple}
            type="file"
            className="invisible absolute top-0 right-0"
            ref={innerRef}
            onChange={handleChange}
            onClick={handleClick}
            accept={fileTypes?.join(', ')}
        />
    );
}
export default FileInput;
